import React from 'react';

const CongratsOrderItem = ({ itemQuantity, itemDesc, itemSize, isHeader }) => {
  return (
    <div className={`congrats-order-item ${isHeader && 'congrats-order-item-header'}`}>
      <p className='text-field'>{itemQuantity}</p>
      <p className='text-field'>{itemDesc}</p>
      <p className='text-field'>{itemSize}</p>
    </div>
  );
};

export default CongratsOrderItem;